import React, { useState } from "react";
import useMultiStepForm from "../../hooks/useMultiStepForm";
import EmployeeWellBeing from "./Form/EmployeeWellBeing";
import Diversity from "./Form/Diversity";
import Community from "./Form/Community";
import Labour from "./Form/Lobour";
import HealthSafty from "./Form/HealthSafty";
import EmployeeBenifits from "./Form/EmployeeBenefits";
import HumanRight from "./Form/HumanRight";
import CustomerSatisfacition from "./Form/CustomerSatisfacition";
import { Route, Router, Routes } from "react-router-dom";
import TrainingDevelopment from "./Form/TrainingDevelopment";

const Social = () => {
  const {
    currentStep,
    nextStep,
    previousStep,
    markStepComplete,
    isStepComplete,
  } = useMultiStepForm(3);
  const [formData, setFormData] = useState({ name: "", age: "" });

  return (
    // <Router>
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <EmployeeWellBeing
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step2"
          element={
            <Diversity
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        {/* <Route
            path="/"
            element={
              <Add
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
              /> */}
        {/* } */}
        {/* /> */}
        <Route
          path="/step3"
          element={
            <Community
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step4"
          element={
            <Labour
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step5"
          element={
            <HealthSafty
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step6"
          element={
            <HumanRight
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step7"
          element={
            <TrainingDevelopment
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step8"
          element={
            <EmployeeBenifits
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
        <Route
          path="/step9"
          element={
            <CustomerSatisfacition
              formData={formData}
              setFormData={setFormData}
              nextStep={nextStep}
              markComplete={markStepComplete}
            />
          }
        />
      </Routes>
    </div>
    // </Router>
  );
};

export default Social;
